import { queryClient } from "@/query-client.ts";
import { useMutation, useQuery } from "@tanstack/react-query";
import caseFilingService from "../services/case-filing-service";

export const useCaseFilingSaveMutation = () => {
	return useMutation({
		mutationKey: ["case-filing", "save-information"],
		mutationFn: caseFilingService.saveCaseInformation,
		meta: {
			successMessage: "Case information saved successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["case-filing"] });
		},
	});
};

export const useCaseFilingAttachmentMutation = () => {
	return useMutation({
		mutationKey: ["case-filing", "save-information"],
		mutationFn: caseFilingService.saveCaseInformationAttachment,
		meta: {
			successMessage: "Case information saved successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["case-filing"] });
		},
	});
};

export const useCaseFilingEvidenceMutation = () => {
	return useMutation({
		mutationKey: ["case-filing", "save-evidence"],
		mutationFn: caseFilingService.saveCaseInformationEvidence,
		meta: {
			successMessage: "Case evidence saved successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["case-filing"] });
		},
	});
};

export const useCaseFilingQuery = (caseId: string) => {
	return useQuery({
		queryKey: ["case-filing", caseId],
		queryFn: () => caseFilingService.getCaseFilingById(caseId),
		enabled: !!caseId,
	});
};
